import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { deleteFeatures, getFeatures, setFeatures } from './feature.value';
import { EcapHttp } from '../http/EcapHttp';
import { ShellDomainProvider } from '../utility/shell-domain.provider'
import { EcapCookieService } from '../cookie/ecap-cookie.service';

const header = new HttpHeaders({
    "Content-Type": "application/json"
});

@Injectable()
export class FeatureProvider {
    private platformIdValue: string;

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) platformId: string,
        private _cookieService: EcapCookieService,
        private ecapHttp: EcapHttp) {
        this.platformIdValue = platformId;
    }

    public getFeatures() {
        const features = getFeatures();
        if (features.length !== 0 && this.platformIdValue === 'browser') {
            return Promise.resolve(getFeatures());
        }
        else if (ShellDomainProvider['api'].isMock) {
            let featureList = [{ 'Type': 'platform', 'Name': 'login', 'Features': ['platform.login'] }];
            if (ShellDomainProvider['mockData']) {
                featureList = ShellDomainProvider['mockData'].featureList;
            }
            setFeatures(featureList);
            return Promise.resolve(featureList);
        }
        else {
            const url = ShellDomainProvider['api'].Apps + "?cacheBuster=" + new Date().getTime()
            return firstValueFrom(this.http.get(url, { headers: header, withCredentials: true })).then(response => {
                setFeatures(response);
                return response;
            }, err => {
                return new Array([]);
            });
        }
    }

    public async getFeaturesSync() {
        const features = getFeatures();
        if (features.length !== 0) {
            return features;
        } else {
            const url = ShellDomainProvider['api'].Apps + "?cacheBuster=" + new Date().getTime();
            const syncFeatures = await firstValueFrom(this.http.get(url, { headers: header, withCredentials: true })).then((res: any) => res);
            setFeatures(syncFeatures);
            return syncFeatures;
        }
    }

  isTokenPresent() {
    if (this.platformIdValue === 'browser' && !this._cookieService.getCookie("REFRESH_TOKEN")) {
      return false
    }
    else if (process.env.ACCESS_TOKEN === 'undefined' || process.env.REFRESH_TOKEN === 'undefined') {
      return false;
    }

    return true;
  }

    public resetFeatures() {
        deleteFeatures();
    }

    public detectBrowser(): string {
        let browserName, nAgt, verOffset;
        nAgt = navigator.userAgent;
        browserName = navigator.appName;
        // In Opera, the true version is after "Opera" or after "Version"
        if ((verOffset = nAgt.indexOf("Opera")) != -1) {
            browserName = "Opera";
        }
        // In Edge, the true version is after "Edge" or after "Version"
        else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
            browserName = "Edge";
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
            browserName = "IE";
        }
        // In Chrome, the true version is after "Chrome"
        else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browserName = "Chrome";
        }
        // In Safari, the true version is after "Safari" or after "Version"
        else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
            browserName = "Safari";
        }
        // In Firefox, the true version is after "Firefox"
        else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
            browserName = "Firefox";
        }
        // In most other browsers, "name/version" is at the end of userAgent
        else if (browserName == 'Netscape') {
            browserName = "IE";
        }
        return browserName;
    }

}
